import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'app-char-limit',
    template: `
    <em class="text-danger" *ngIf="isExceeded">Too long by {{remaining}} character(s) — maximum limit is {{maxLength}} characters</em>
    <em class="text-danger" *ngIf="hasValue">{{remaining}} character(s) left</em>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CharLimitComponent {
  @Input() control: AbstractControl;
  @Input() maxLength: number;

  get value(): string {
    return this.control?.value || '';
  }

  get hasValue(): boolean {
    return this.value.length > 0 && this.value.length <= this.maxLength;
  }

  get isExceeded(): boolean {
    return this.value.length > this.maxLength;
  }

  get remaining(): number {
    return this.maxLength - this.value.length;
  }
}
